import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { BulletinHistoryDescriptor } from './model/bulletin.history';

@Injectable()
export class BulletinHistoryService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'BulletinHistoryManagement',
      authService,
      config.BMSConfig
    );
  }

  public create(bulletinHistory: BulletinHistoryDescriptor): Promise<BulletinHistoryDescriptor> {
    return super.post<BulletinHistoryDescriptor>(
      new BulletinHistoryDescriptor({
        id: undefined,
        href: undefined,
        body: bulletinHistory.body,
        bulletinId: bulletinHistory.bulletinId,
        bulletinState: bulletinHistory.bulletinState,
        createdBy: bulletinHistory.createdBy,
        createdOn: new Date(),
        isPublic: bulletinHistory.isPublic,
        modified: bulletinHistory.modified,
        deleted: bulletinHistory.deleted
      }));
  }

  public getBulletinHistories(view?: View): Promise<List<BulletinHistoryDescriptor>> {
    return super.get<List<BulletinHistoryDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public getById(id: string): Promise<BulletinHistoryDescriptor> {
    return super.get<BulletinHistoryDescriptor>(id);
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/bulletin.history/bulletin.history.service.ts